import React from 'react';
import { jObjectLittle, jUserLittle, Model } from 'jamespot-user-api';
import styled from 'styled-components';
import { JRCTypography } from '../JRCTypography/JRCTypography';

export type JRCUserHighlightFieldsProps = {
    user: jUserLittle;
    highlightFields: string[];
    userModel: Model;
};

const HighlightFields = styled.div`
    display: flex;
    gap: 4px;
`;
export const JRCUserHighlightFields = ({ user, highlightFields, userModel }: JRCUserHighlightFieldsProps) => {
    const fields = highlightFields
        .map((highlightField) => {
            const field = user[highlightField];
            const fieldModel = userModel.fields[highlightField];
            if (typeof field === 'string') {
                return field;
            }
            if (!fieldModel) {
                return null;
            }
            if (fieldModel.widget.type === 'taxonomy' && Array.isArray(field)) {
                return field.map((v: { uri: string; type: string; title: string }) => v.title).join(', ');
            } else if (['uri', 'orientedlinks'].includes(fieldModel.widget.type) && Array.isArray(field)) {
                return field.map((v: jObjectLittle) => v.title).join(', ');
            } else {
                return null;
            }
        })
        .filter((v) => v !== null && v !== '');

    return (
        <HighlightFields>
            {fields.map((field, i) => (
                <HighlightFields key={i}>
                    {i > 0 && (
                        <JRCTypography size={'s'} color={'grey4'}>
                            •
                        </JRCTypography>
                    )}
                    <JRCTypography size={'s'} color={'grey4'}>
                        {field}
                    </JRCTypography>
                </HighlightFields>
            ))}
        </HighlightFields>
    );
};
